<template>
  <div v-if="isLogin">
    <div v-if="loading">
      <div class="row">
        <div class="col-12">
          <label class="font28 font500 mr-2">
            <i class="fas fa-comment-dots fa-13"></i> ส่งข้อความ
          </label>
          <label v-if="!checkfrom">
            <div class="font18">/ รายการหมายเลขที่จะส่งข้อความ</div>
          </label>
        </div>
      </div>
      <div class="row" v-if="checkfrom">
        <div class="col-12 py-1">
          <div class="bg-blue font14">
            <div>
              -
              หากจำนวนตัวอักษรเกินกว่ากำหนดระบบจะตัดเครดิตของท่านตามข้อความที่ใช้
              หากแต่ผู้รับจะได้รับเป็นข้อความเดียว
            </div>
            <div>
              - เช่น หากข้อความของท่านเป็นภาษาไทยเกิน 70 ตัวอักษร ระบบจะคิดเป็น
              2 ข้อความแต่ผู้รับจะได้รับเพียงข้อความเดียวครบถ้วน
            </div>
            <div>
              - ข้อความที่จะส่งความยาวจะต้องไม่เกิน 670 ตัวอักษรสำหรับภาษาไทย ,
              1350 ตัวอักษรสำหรับภาษาอังกฤษ ถ้าส่งข้อความยาวมากตั้งแต่ 336
              (ภาษาไทย) หริอ 766 (ภาษาอังกฤษ) ตัวอักษรขึ้นไปมือถือ
              บางรุ่นอาจจะได้ข้อความไม่ครบ
              หรือข้อความที่แสดงบนหน้าจอไม่รวมเป็นข้อความเดียว
              จำนวนความยาวที่ดีที่สุดไม่ควรเกิน 335 (ภาษาไทย) และ 765 ตัวอักษร
              (ภาษาอังกฤษ)
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3" v-if="checkfrom">
        <div class="col-12">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <span
                class="nav-link"
                id="settings-tab"
                data-toggle="tab"
                href="#settings"
                role="tab"
                aria-controls="settings"
                aria-selected="false"
                >เลือกประเภทการส่ง</span
              >
            </li>
            <li class="nav-item mystyle">
              <!-- <a class="nav-link active 1" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true" @click="onclicktab('1')">ระบุเบอร์โทรศัพท์</a> -->
              <a
                class="nav-link"
                @click.prevent="setActive('1')"
                :class="{ active: isActive('1') }"
                href="#1"
                >ระบุเบอร์โทรศัพท์</a
              >
            </li>
            <li class="nav-item mystyle">
              <!-- <a class="nav-link upload_file" id="profile-tab" data-toggle="tab" role="tab" aria-controls="profile" aria-selected="false" @click="onclicktab('upload_file')">อัพโหลดไฟล์</a> -->
              <a
                class="nav-link"
                @click.prevent="setActive('2')"
                :class="{ active: isActive('2') }"
                href="#2"
                >อัพโหลดไฟล์</a
              >
            </li>
            <li class="nav-item mystyle">
              <!-- <a class="nav-link 3" id="messages-tab" data-toggle="tab" role="tab" aria-controls="messages" aria-selected="false" @click="onclicktab('3')">ส่งตามสมุดโทรศัพท์</a> -->
              <a
                class="nav-link"
                @click.prevent="setActive('3')"
                :class="{ active: isActive('3') }"
                href="#3"
                >ส่งตามสมุดโทรศัพท์</a
              >
            </li>
          </ul>

          <!-- Tab panes Menu-->
          <div class="tab-content">
            <div class="row">
              <div class="align-self-center ml-3">ผู้ส่ง</div>
              <div class="col-12 col-md-3 p-2">
                <select
                  class="custom-select custom-select-sm"
                  id="selectsender"
                  v-model="sender"
                >
                  <option value disabled>เลือกผู้ส่ง</option>
                  <option
                    v-for="val in sender_name"
                    :key="val.id"
                    v-bind:value="val.sender_name"
                    v-bind:id="val.id"
                  >
                    {{ val.sender_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="align-self-center ml-3">ตัวเลือกการส่ง</div>
              <div class="col-12 col-md-3 p-2">
                <select
                  class="custom-select custom-select-sm"
                  id="selecttime"
                  v-model="choose_to_send"
                >
                  <option value disabled>เลือกการส่ง</option>
                  <option value="1">ส่งทันที</option>
                  <option value="2">ตั้งเวลาส่ง</option>
                </select>
              </div>
              <div class="row" v-if="choose_to_send == '2'">
                <div class="align-self-center ml-4">วัน / เวลา ที่ส่ง</div>
                <div class="col-md-3 mt-2 ml-3">
                  <date-picker
                    class="input-date"
                    style="margin-left: -8px"
                    valuetype="format"
                    type="datetime"
                    :format="momentFormat"
                    :value="this.data.date_set"
                    lang="en"
                    v-model="dateselect"
                  ></date-picker>
                </div>
              </div>
            </div>

            <!---------------------------------------------------------------------------------------->
            <!-- <div class="tab-pane 1 active" role="tabpanel" aria-labelledby="home-tab"> -->
            <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('1') }"
              id="1"
            >
              <div class="font14 mt-3">
                กรอกหมายเลขโทรศัพท์มือถือ
                <label style="color: red">(ไม่เกิน 30,000 เบอร์) *</label>
              </div>
              <div class="row">
                <div class="col-12">
                  <textarea
                    v-model="dataphone"
                    @keypress="isNumber($event)"
                    rows="5"
                    style="width: 100%"
                  ></textarea>
                </div>
              </div>
              <div class="font14 color_gray">
                - หมายเลข 10 หลัก และใช้เครื่องหมาย , คั่น เช่น
                0812345678,0812345679
              </div>
              <div class="font14 color_gray">
                - หรือ สามารถ Copy หมายเลขโทรศัพท์ จาก text editer ,excel
                มาวางได้
                โดยข้อมูลจะต้องเป็นหนึ่งหมายเลขต่อหนึ่งบรรทัดเรียงกันลงมา
              </div>
            </div>

            <!-- <div class="tab-pane upload_file mt-3 mb-2" role="tabpanel" aria-labelledby="profile-tab"> -->
            <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('2') }"
              id="2"
            >
              <div class="row mt-4 ml-md-1 mb-2">
                <!-- <mdb-file-input v-model="uploadfile" @getValue="getFileInputValue" btnColor="mdb-color" rounded btn-title="เลือกไฟล์" />
                <mdb-btn class="btn-uploadfile my-2 ml-2" @click="uploadfile_post()"><mdb-icon icon="file-upload" /> Upload File</mdb-btn>-->
                <!-- <div class="px-2 ml-md-4 mt-4 mb-3" style="max-width:500px;">
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text" id="inputGroupFileAddon01">File Upload</span>
										</div>
										<div class="custom-file">
											<input type="file" class="custom-file-input" id="inputGroupFile01" :v-model="uploadfile" aria-describedby="inputGroupFileAddon01" />
											<label class="custom-file-label" for="inputGroupFile01">Choose file</label>
										</div>
									</div>
                </div>-->

                <div id="app">
                  <label>
                    <b class="ml-3">File</b>
                    <input
                      id="file"
                      type="file"
                      class="px-2"
                      ref="file"
                      style="max-width: 250px"
                      @change="handleFileUpload()"
                    />
                  </label>
                  <mdb-btn
                    class="btn-uploadfile py-2 px-3 ml-3 mt-2 mb-3 btn_upload"
                    id="btn_upload"
                    v-if="btn_upload"
                    @click="uploadfile_post()"
                  >
                    <mdb-icon icon="file-upload" />Upload File
                  </mdb-btn>
                  <mdb-btn
                    class="btn-uploadfile py-2 px-3 ml-3 mt-2 mb-3 btn_cancel"
                    id="btn_cancel"
                    v-if="btn_cancel"
                    @click="uploadfile_cancel()"
                  >
                    <mdb-icon icon="times" />Cancel
                  </mdb-btn>
                </div>

                <!-- <mdb-file-input sm btnColor="primary" type="file" class="mr-4" v-model="payload.file" />
                <mdb-btn class="btn-uploadfile p-2 mt-2 mb-3" @click="uploadfile_post()"><mdb-icon icon="file-upload" /> Upload File</mdb-btn>-->
              </div>
              <div class="font14 color_gray">
                **อัพโหลดไฟล์ขนาดไม่เกิน 5 MB และกรุณาใช้ฟอร์แมตไฟล์ตามที่กำหนด
                (นามสกุลไฟล์)
              </div>
              <div class="font14 color_gray">- .txt (ANSI/ASCII,UTF-8)</div>
              <div class="font14 color_gray">- .csv (Comma delimited)</div>
            </div>

            <!-- <div class="tab-pane 3" role="tabpanel" aria-labelledby="messages-tab"> -->
            <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('3') }"
              id="3"
            >
              <div class="font14 mt-3">เลือกสมุดโทรศัพท์</div>
              <div class="row">
                <div class="col-12 col-md-5">
                  <div class="row">
                    <div class="col-6">
                      <label class="color_orange font14 mt-3"
                        >รายชื่อสมุดโทรศัพท์</label
                      >
                    </div>
                    <!-- <div class="col-6 text-right">
										<label class="color_orange font14 mt-3">
											<div class="custom-control custom-checkbox">
												<input type="checkbox" class="custom-control-input" id="checkAll" v-model="checkAll" @click="checkAll()" checked />
												<label class="custom-control-label check" for="checkAll">เลือกทั้งหมด</label>
											</div>
										</label>
                    </div>-->
                  </div>
                  <ul class="list-group list-group-flush box-message">
                    <li
                      class="list-group-item pt-0 pb-0"
                      v-for="item in bookbefore"
                      :key="item.phone"
                    >
                      <!-- Default checked -->
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="item.name"
                          v-model="item.IsCheck"
                        />
                        <label class="custom-control-label" :for="item.name">{{
                          item.phone
                        }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="align-self-center col-12 col-md-2 text-center">
                  <div>
                    <mdb-btn
                      class="btn-select-information font14"
                      @click="OnclickUse(1)"
                    >
                      เลือกใช้
                      <mdb-icon icon="angle-double-right" />
                    </mdb-btn>
                  </div>
                  <div>
                    <mdb-btn
                      class="btn-select-information-cancle font14"
                      @click="OnclickUse(0)"
                    >
                      <mdb-icon icon="angle-double-left" />ลบ
                    </mdb-btn>
                  </div>
                </div>
                <div class="col-12 col-md-5">
                  <div class="row">
                    <div class="col-6">
                      <label class="color_orange font14 mt-3"
                        >รายชื่อสมุดโทรศัพท์</label
                      >
                    </div>
                  </div>
                  <ul class="list-group list-group-flush box-message">
                    <li
                      class="list-group-item pt-0 pb-0"
                      v-for="item in bookbeafter"
                      :key="item.phone"
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="item.name"
                          v-model="item.IsCheck"
                        />
                        <label class="custom-control-label" :for="item.name">{{
                          item.phone
                        }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="font14 mt-3">
                  ระบุข้อความที่ต้องการส่ง
                  <label style="color: red">*</label>
                </div>

                <textarea
                  v-model="data.message"
                  @keyup="charCount()"
                  rows="5"
                  style="width: 100%"
                  maxlength="336"
                ></textarea>

                <div class="row justify-content-center">
                  <div class="col-12 text-center color_orange font18 mt-3">
                    คำนวณการจ่ายเครดิตของการส่งข้อความ
                  </div>
                  <div class="col-12 col-md-10 bg-calculate p-4 mt-3 font14">
                    <div class="row">
                      <div class="col-0 col-md-3"></div>
                      <div class="col-12 col-md-9 color_white mb-3">
                        จำนวนตัวอักษร
                        <label class="bg-calculate-white mr-2">{{
                          totalcharacter
                            ? totalcharacter
                            : this.data.message.length
                        }}</label>
                        คิดเป็น
                        <span class="bg-calculate-white">{{
                          totalcharacter2
                        }}</span>
                        ข้อความ
                      </div>
                      <div class="col-0 col-md-3"></div>
                      <div class="col-12 col-md-9 color_white mb-3">
                        จำนวนเบอร์โทรศัพท์
                        <span class="bg-calculate-white mr-3">{{
                          (totaldataphone =
                            textgroup != "" ? textgroup : totaldataphone)
                        }}</span>
                        ใช้เครดิตทั้งหมด
                        <span class="bg-calculate-white">{{
                          (amountcharacter = totalcharacter2 * totaldataphone)
                        }}</span>
                        เครดิต
                      </div>
                      <div class="col-0 col-md-3"></div>
                      <div class="col-12 col-md-9 font16 color_white">
                        เครดิตปัจจุบัน
                        <span class="color_orange ml-2 mr-3">{{
                          user.credit
                        }}</span
                        >เครดิตคงเหลือ
                        <span class="color_orange ml-2">{{
                          (remaining_credit = user.credit - amountcharacter)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-10 text-center color_red font14 mt-4"
                  >
                    หลังจากที่ท่านได้จัดการข้อมูลเสร็จแล้ว กรุณาคลิกที่ปุ่ม
                    "ตรวจสอบข้อมูล" เพื่อตรวจสอบข้อมูลก่อนส่ง
                    เมื่อตรวจสอบข้อมูลเสร็จแล้วถ้าต้องการส่งให้คลิกที่ปุ่ม
                    "ยืนยันการส่งข้อความ" ถ้าต้องการยกเลิกการส่งคลิกที่ปุ่ม
                    "ยกเลิกการส่งข้อควม" ขออภัยในความไม่สะดวกค่ะ
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center mt-3"></div>
      </div>
      <div v-if="!checkfrom">
        <div>
          <mdb-datatable
            :arrows="true"
            :data="dataview"
            striped
            bordered
            :searching="true"
            scrollY
            maxHeight="500px"
          />
        </div>
      </div>
      <div class="col-12 text-center mt-3">
        <mdb-btn
          v-if="!checkfrom"
          class="btn-Check-information font14"
          @click.native="OnSaveData()"
        >
          <mdb-icon icon="save" />บันทึกข้อมูล
        </mdb-btn>
        <mdb-btn
          v-if="!checkfrom"
          class="btn-Check-information-cancle font14"
          @click.native="OnCancleData()"
        >
          <mdb-icon icon="angle-double-left" />ย้อนกลับ
        </mdb-btn>
        <a
          href="#"
          v-if="checkfrom"
          class="btn-Check-information text-white pl-3 pr-3 font14"
          @click="CheckForm()"
        >
          <mdb-icon icon="marker" />ตรวจสอบข้อมูล
        </a>
        <mdb-btn
          v-if="checkfrom"
          class="btn-Check-information-cancle font14"
          @click="cancel()"
        >
          <i class="fas fa-times"></i> ยกเลิก
        </mdb-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import {mdbFileInput} from 'mdbvue'
// import VueEmoji from 'emoji-vue'
// import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import moment from "moment";
// import $ from 'jquery'
export default {
  name: "EditSendmessagelist",
  data() {
    return {
      loading: false,
      is_dateset: true,
      btn_cancel: false,
      btn_upload: true,
      momentFormat: {
        stringify: (date) => {
          if (this.is_dateset) {
            date = this.data.date_set;
            this.is_dateset = false;
          }
          this.data.date_set = date;
          return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        parse: (value) => {
          return moment(value).format("YYYY-MM-DD HH:mm:ss");
        },
      },
      sender: "",
      type_send: "",
      choose_to_send: "",
      dataphone: "",
      bookbeafter: [],
      message: "",
      totalcharacter: 0,
      totalcharacter2: 0,
      totaldataphone: 0,
      usecharactter: 0,
      id_refer: 0,
      data: [],
      activeItem: "1",
      getFileInputValue: "",
      phonebook_send: "",
      dateselect: new Date(),
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: ["headings", "bold", "link", "|", "image", "undo", "redo"],
        },
      },
      bookbefore: [],
      dataview: [],

      payload: {
        file: "",
        title: "message",
      },

      data_sender: [],
      sender_name: [],
      data_payload: null,
      checkfrom: true,
      showModal: false,
      file: null,
      id_upload_file: null,
      isreturn_id: null,
      textgroup: 0,
      reff_id: null,
      selectgroup: "",
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      token: "token",
    }),
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    uploadfile_post() {
      if (document.getElementById("file").files.length == 0) {
        this.$swal({
          icon: "error",
          html: "<br>กรุณาเลือก ไฟล์อัพโหลดก่อน!!!<br>",
          timer: 8000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("title", "edite");
        formData.append("id", this.data.id);
        this.$axios
          .post("/upload_file", formData, {
            headers: {
              Authorization: this.token.headers.Authorization,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            (this.btn_cancel = true),
              (this.btn_upload = false),
              (this.id_upload_file = res.data.id);
            this.$swal({
              icon: "success",
              html: "<br>อัพโหลดไฟล์เรียบร้อยแล้ว<br>",
              timer: 8000,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          })
          .catch(function () {});
      }
    },
    uploadfile_cancel() {
      (this.btn_cancel = false), (this.btn_upload = true);
      let payload = {
        phone_number: this.data.phon_number,
        id: this.id_upload_file ? this.id_upload_file : this.isreturn_id, //wait api
        title: "cancel_update",
      };
      this.callApiMotherFucker({
        method: "post",
        path: "/upload_file",
        data: payload,
      }).then(() => {
        this.$swal({
          icon: "success",
          html: "<br>ยกเลิกอัพโหลดไฟล์เรียบร้อยแล้ว<br>",
          timer: 8000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        window.location.reload();
      });
    },

    charCount() {
      this.totalcharacter = this.message.length;
      if (this.totalcharacter > 603) {
        this.totalcharacter2 = 10;
      } else if (this.totalcharacter > 536) {
        this.totalcharacter2 = 9;
      } else if (this.totalcharacter > 469) {
        this.totalcharacter2 = 8;
      } else if (this.totalcharacter > 402) {
        this.totalcharacter2 = 7;
      } else if (this.totalcharacter > 335) {
        this.totalcharacter2 = 6;
      } else if (this.totalcharacter > 268) {
        this.totalcharacter2 = 5;
      } else if (this.totalcharacter > 201) {
        this.totalcharacter2 = 4;
      } else if (this.totalcharacter > 134) {
        this.totalcharacter2 = 3;
      } else if (this.totalcharacter > 70) {
        this.totalcharacter2 = 2;
      } else if (this.totalcharacter > 0) {
        this.totalcharacter2 = 1;
      } else {
        this.totalcharacter2 = 0;
      }
    },

    CheckForm() {
      this.loading = false;
      if (this.sender == "") {
        return this.$swal({
          html:
            '<i class="fa fa-user-alt fa-6x"></i><br><br>กรุณาเลือกผู้ส่ง<br>',
          timer: 8000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      if (this.choose_to_send == "") {
        return this.$swal({
          html:
            '<i class="fa fa-paper-plane fa-6x"></i><br><br>กรุณาเลือกการส่ง<br>',
          timer: 8000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      if (this.activeItem == "2") {
        if (this.id_upload_file == "" || this.id_upload_file == null) {
          this.loading = true;
          return this.$swal({
            html:
              '<i class="fa fa-file-upload fa-6x"></i><br><br>กรุณาอัพโหลดไฟล์<br>',
            timer: 8000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      }
      if (this.activeItem == "3") {
        if (this.bookbeafter == "" || this.bookbeafter == null) {
          this.loading = true;
          return this.$swal({
            html:
              '<i class="fa fa-address-book fa-6x"></i><br><br>กรุณาเลือกสมุดโทรศัพท์<br>',
            timer: 8000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      }
      if (this.message == "") {
        return this.$swal({
          html: '<i class="fa fa-edit fa-6x"></i><br><br>กรุณาระบุข้อความ<br>',
          timer: 8000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }

      this.checkfrom = false;
      this.dataview = {
        columns: [
          {
            label: "NO.",
            field: "id2",
            sort: true,
          },
          {
            label: "Message",
            field: "msg",
            sort: true,
          },
          {
            label: "Phone No",
            field: "phone_number",
            sort: true,
          },
          {
            label: "Schedule Date",
            field: "date",
            sort: true,
          },
          {
            label: "Sender",
            field: "sender",
            sort: true,
          },
          {
            label: "Credit",
            field: "credit",
            sort: true,
          },
        ],
        rows: null,
      };
      if (this.totalcharacter < 70) {
        this.totalcharacter = 70;
      }
      if (this.choose_to_send == "1") {
        this.dateselect = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      }
      ///////////////////////////////////////////////////////////////
      if (this.activeItem == "1" || this.activeItem == 1) {
        let payload = {
          sender: this.sender,
          type_send: this.activeItem,
          message: this.data.message,
          phone_number: this.dataphone,
          timetype: this.choose_to_send
            ? this.choose_to_send
            : this.data.type_send,
          sentdate:
            moment(this.dateselect).format("YYYY-MM-DD HH:mm") ===
            moment(new Date()).format("YYYY-MM-DD HH:mm")
              ? moment(this.data.date_set).format("YYYY-MM-DD HH:mm:ss")
              : moment(this.dateselect).format("YYYY-MM-DD HH:mm:ss"),
          length_mss: this.totalcharacter,
          length_use: this.usecharactter,
          use_credit: this.amountcharacter,
          amount_phome: this.totaldataphone,
          id: this.data.id,
        };
        let dataphoneview = [];
        let arrphone = this.dataphone.split(",");
        if (arrphone.length > 0) {
          arrphone.forEach((phone) => {
            dataphoneview.push({
              msg: this.message,
              phoneno: phone,
              schdata: this.dateselect,
              sender: this.sender,
              credit: this.amountcharacter,
            });
          });
        }

        this.callApiMotherFucker({
          method: "POST",
          path: "/message",
          data: payload,
        }).then((res) => {
          this.loading = true;
          this.data_payload = res.stament;
          var payload = res.payload.splice(1);
          this.dataview.rows = this.$add_index(payload);
          this.dataview.rows.forEach((value, index) => {
            if (index != 0) {
              console.log(index);
              this.dataview.rows[index].msg = value.msg;
              this.dataview.rows[index].phone_number = value.phone_number;
              this.dataview.rows[index].date = value.date;
              this.dataview.rows[index].sender = value.sender;
              this.dataview.rows[index].credit = value.credit;
            }
          });
          this.loading = true;
          this.isreturn_id = res.id;
        });
      } else if (this.activeItem == "2") {
        let payload = {
          sender: this.sender,
          type_send: this.activeItem,
          message: this.data.message,
          phone_number: this.dataphone,
          timetype: this.choose_to_send
            ? this.choose_to_send
            : this.data.type_send,
          sentdate:
            moment(this.dateselect).format("YYYY-MM-DD HH:mm") ===
            moment(new Date()).format("YYYY-MM-DD HH:mm")
              ? moment(this.data.date_set).format("YYYY-MM-DD HH:mm:ss")
              : moment(this.dateselect).format("YYYY-MM-DD HH:mm:ss"),
          length_mss: this.totalcharacter,
          length_use: this.usecharactter,
          use_credit: this.amountcharacter,
          amount_phome: this.totaldataphone,
          id: this.data.id,
        };
        let dataphoneview = [];
        let arrphone = this.dataphone.split(",");
        if (arrphone.length > 0) {
          arrphone.forEach((phone) => {
            console.log("object");
            dataphoneview.push({
              msg: this.message,
              phoneno: phone,
              schdata: this.dateselect,
              sender: this.sender,
              credit: this.amountcharacter,
            });
          });
        }

        this.callApiMotherFucker({
          method: "POST",
          path: "/message",
          data: payload,
        }).then((res) => {
          this.loading = true;
          this.data_payload = res.stament;
          var payload = res.payload.splice(1);
          this.dataview.rows = this.$add_index(payload);
          this.dataview.rows.forEach((value, index) => {
            if (index != 0) {
              console.log(index);
              this.dataview.rows[index].msg = value.msg;
              this.dataview.rows[index].phone_number = value.phone_number;
              this.dataview.rows[index].date = value.date;
              this.dataview.rows[index].sender = value.sender;
              this.dataview.rows[index].credit = value.credit;
            }
          });
          this.loading = true;
          this.isreturn_id = res.id;
        });
      } else if (this.activeItem == "3") {
        console.log(
          moment(this.dateselect).format("YYYY-MM-DD HH:mm") <=
            moment(new Date()).format("YYYY-MM-DD HH:mm")
        );
        let payload = {
          sender: this.sender,
          type_send: this.activeItem,
          message: this.data.message,
          phone_number: "",
          timetype: this.choose_to_send
            ? this.choose_to_send
            : this.data.type_send,
          sentdate:
            moment(this.dateselect).format("YYYY-MM-DD HH:mm") <=
            moment(new Date()).format("YYYY-MM-DD HH:mm")
              ? moment(this.data.date_set).format("YYYY-MM-DD HH:mm:ss")
              : moment(this.dateselect).format("YYYY-MM-DD HH:mm:ss"),
          length_mss: this.totalcharacter,
          length_use: this.usecharactter,
          use_credit: this.amountcharacter,
          amount_phome: this.totaldataphone,
          id: this.data.id,
          group: this.selectgroup,
        };
        let dataphoneview = [];
        let arrphone = this.dataphone.split(",");
        if (arrphone.length > 0) {
          arrphone.forEach((phone) => {
            console.log("object");
            dataphoneview.push({
              msg: this.message,
              phoneno: phone,
              schdata: this.dateselect,
              sender: this.sender,
              credit: this.amountcharacter,
            });
          });
        }

        this.callApiMotherFucker({
          method: "POST",
          path: "/message",
          data: payload,
        }).then((res) => {
          this.loading = true;
          this.data_payload = res.stament;
          var payload = res.payload.splice(1);
          this.dataview.rows = this.$add_index(payload);
          this.dataview.rows.forEach((value, index) => {
            if (index != 0) {
              console.log(index);
              this.dataview.rows[index].msg = value.msg;
              this.dataview.rows[index].phone_number = value.phone_number;
              this.dataview.rows[index].date = value.date;
              this.dataview.rows[index].sender = value.sender;
              this.dataview.rows[index].credit = value.credit;
            }
          });
          this.loading = true;
          this.isreturn_id = res.id;
        });
      }
    },
    cancel() {
      this.$router.push("/EditSendmessage");
    },
    OnCancleData() {
      let payload = {
        id: this.isreturn_id, //wait api
        rowkey: "cancel",
        confirm: "cancel",
      };
      this.callApiMotherFucker({
        method: "post",
        path: "/message",
        data: payload,
      }).then(() => {
        this.$router.push("/EditSendmessage");
      });
    },
    OnSaveData() {
      let payload = {
        id: this.isreturn_id, //wait api
        rowkey: "approve",
        confirm: "approve",
        type_send: this.data_payload,
      };
      this.callApiMotherFucker({
        method: "post",
        path: "/message",
        data: payload,
      }).then((res) => {
        console.log("ress", res);
        if (res.code == 0) {
          this.$swal({
            icon: "success",
            html: res.msg,
            timer: 8000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          this.$router.push("/EditSendmessage");
        } else {
          this.$swal({
            icon: "error",
            html: res.msg,
            timer: 8000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          this.$router.push("/EditSendmessage");
        }
      });
    },
    async OnclickUse(type) {
      if (type == 1) {
        let databefor = this.bookbefore;
        this.bookbefore = [];
        databefor.forEach((element) => {
          if (element.IsCheck) {
            this.bookbeafter.push(element);
            element.IsCheck = true;
          } else {
            this.bookbefore.push(element);
          }
        });
        this.textgroup = "";
        this.bookbeafter.forEach((element) => {
          if (this.bookbeafter.length == 1) {
            this.textgroup = element.id + "^" + element.name + "[7C]";
          } else {
            console.log("element", element);
            this.textgroup += element.id + "^" + element.name + "[7C]";
          }
        });
        this.selectgroup = this.textgroup.substring(
          0,
          this.textgroup.length - 4
        );
        let payload = {
          objvalue: this.textgroup.substring(0, this.textgroup.length - 4),
          name: "useCreditOld",
          rowkey: "new",
        };
        await this.callApiMotherFucker({
          method: "post",
          path: "/get_phonenumber",
          data: payload,
        }).then((res) => {
          this.textgroup = res.payload;
        });
      } else {
        let dataafter = this.bookbeafter;
        this.bookbeafter = [];
        dataafter.forEach((element) => {
          if (element.IsCheck) {
            element.IsCheck = false;
            this.bookbefore.push(element);
          } else {
            this.bookbeafter.push(element);
          }
        });
        this.textgroup = "";
        this.bookbeafter.forEach((element) => {
          if (this.bookbeafter.length == 1) {
            this.textgroup = element.id + "^" + element.name + "[7C]";
          } else {
            console.log("element", element);
            this.textgroup += element.id + "^" + element.name + "[7C]";
          }
        });
        this.selectgroup = this.textgroup.substring(
          0,
          this.textgroup.length - 4
        );
        let payload = {
          objvalue: this.textgroup.substring(0, this.textgroup.length - 4),
          name: "useCreditOld",
          rowkey: "new",
        };
        await this.callApiMotherFucker({
          method: "post",
          path: "/get_phonenumber",
          data: payload,
        }).then((res) => {
          this.textgroup = res.payload;
        });
      }
    },
    // Dataphone() {
    // 	this.totaldataphone = this.dataphone.split(',').length
    // },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode == 60 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else {
        this.totaldataphone = this.dataphone.split(",").length;
        return true;
      }
    },

    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
  },
  async mounted() {
    this.loading = true;
    if (!this.isLogin) {
      this.$router.push("/Logout");
    }
    await this.callApiMotherFucker({
      method: "get",
      path: "/bookphone",
      data: {},
    }).then((res) => {
      // console.log('this.data.rows bookphone ', res.payload)
      if (res.payload) {
        this.data = this.$add_index(res.payload);
        this.data.forEach((value) => {
          this.bookbefore.push({
            name: value.book_name,
            phone: value.book_name,
            IsCheck: false,
            IsSend: false,
            id: value.id_refer,
          });
        });
      }
    });

    await this.callApiMotherFucker({
      method: "post",
      path: "/sender/All",
      data: {},
    }).then((res) => {
      this.loading = true;
      this.data_sender = [];
      this.sender_name = [];
      if (res.payload) {
        this.data_sender = this.$add_index(res.payload);
        // console.log(this.data_sender)
        this.data_sender.forEach((value) => {
          if (value.status == 0) {
            this.sender_name.push({
              id: value.id,
              sender_name: value.sender_name,
            });
          }
        });
      }
      // console.log('this.data.rows sender ', this.sender_name)
    });
    await this.callApiMotherFucker({
      method: "post",
      path: "/find_message",
      data: { id: this.$route.query.edit },
    }).then((res) => {
      this.loading = true;
      // console.log('this.data.rows bookphone ', res.payload)
      if (res.payload) {
        this.data = res.payload;
        this.choose_to_send = res.payload.type_send;
        this.message = res.payload.message;
        this.isreturn_id = res.payload.id;
        this.usecharactter = res.payload.message.length;
        this.totalcharacter2 =
          parseInt(res.payload.message.length / 70) <= 0
            ? 1
            : parseInt(res.payload.message.length / 70 + 1);
      }
    });
    // this.dateselect = moment(this.data.date_set).format(
    //   "ddd MMM D YYYY HH:mm:ss"
    // );

    var sender = document.getElementById("selectsender");
    for (var i = 0; i < sender.options.length; i++) {
      if (sender.options[i].value === this.data.sender) {
        document
          .getElementById("selectsender")
          .children[i].setAttribute("selected", "selected");
        this.sender = this.data.sender;
      }
    }
    i = 0;
    var timetpye = document.getElementById("selecttime");
    for (var v = 0; v < timetpye.options.length; v++) {
      if (timetpye.options[v].value === this.data.type_send.toString()) {
        document
          .getElementById("selecttime")
          .children[v].setAttribute("selected", "selected");
      }
    }
  },
};
</script>
<style scoped>
.md-form {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
.mystyle {
  color: #f5904b !important;
}
a {
  color: #f5904b;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #ffffff;
  background-color: #f5904b;
  border-color: #dee2e6 #dee2e6 #fff;
  border-radius: 5px;
}
.emoji-wysiwyg-editor .emoji-vue-textarea {
  height: 150px !important;
}
.bg-calculate {
  background: #333333;
  border-radius: 5px;
}
.bg-calculate-white {
  background: #ffffff;
  color: #f5904b;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0px 10px 0px 10px;
  font-weight: 400;
}
.btn-Check-information {
  background: #f5904b !important;
  border-radius: 10px !important;
  width: 175px;
  padding: 11px 0px 11px 0px;
}
.btn-Check-information-cancle {
  background: #232323 !important;
  border-radius: 10px !important;
  width: 100px;
  padding: 11px 0px 11px 0px;
}
.btn-select-information {
  background: #f5904b !important;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px !important;
  width: 50%;
  min-width: 97px;
  padding: 10px 15px 10px 15px;
  margin-left: 0px;
  margin-right: 0px;
}
.btn-select-information-cancle {
  background: #232323 !important;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px !important;
  width: 50%;
  min-width: 97px;
  padding: 10px 15px 10px 15px;
  margin-left: 0px;
  margin-right: 0px;
}

.box-message {
  border: 1px solid grey;
  border-radius: 3px;
  padding: 8px;
  overflow: auto;
  max-height: 250px;
  height: 250px;
}

.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #ffffff;
  content: "Browse";
  background-color: #f5904b;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}
</style>
